<template>
    <div class="machine-selector-wrapper" >
        <div class="machine-selector">
            <div class="machine-selector-header">
                <h3>Seleccione la máquina correspondiente</h3>
            </div>
            <div class="machine-selector-container">
                <a v-for="machine in machinesProp" :key="machine.id" class="btn btn-primary machine-button col-xl-3 col-md-5 col-12" :href="'machine-production-control/'+machine.id">
                    {{ machine.descrip }}
                </a>
            </div>
        </div>
        <div class="home-button-container">
            <div class="btn btn-primary home-button" @click="goHome">
                <span class="mdi mdi-home" ></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "machine-selector-component",
    props:{
        machinesProp:{
            type: Array,
            required: true
        }
    },
    data() {
        return {
            token: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
    },
    methods:{
        goHome(){
            window.location.href = '/home';
        }
    }
}
</script>